import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PartRequest } from "@vendata/power-up-spec";

export const useCreatePart = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: PartRequest) => {
      return handleClientMethod(getClient().POST("/parts", { body: data }));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["parts", "list"] });
    },
  });
};
